import * as React from 'react';
import { getAssetPath } from '../../util/images';
import ActionModal from '../Modal/ActionModal';

const SaveSceneModal = props => {
  const { onHide, onConfirm, show } = props;
  return (
    <ActionModal
      onHide={() => onHide()}
      onConfirm={() => onConfirm()}
      show={show}
      icon={getAssetPath('icons/configuration-icon.svg')}
      title=""
      header="Save scene?"
      description="Scene will be send and saved in database."
    />
  );
};

export default SaveSceneModal;
